import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getMarathonParticipantImageByFileId } from "api/thunk/marathonParticipantImages/getActions/getMarathonParticipantImageByFileId";

const marathonParticipantImagesSlice = createSlice({
  name: "marathonParticipantImages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMarathonParticipantImageByFileId.pending, (state) => {
        state.marathonParticipantImageByFileId.response.loading = true;
        state.marathonParticipantImageByFileId.response.error = null;
      })

      .addCase(getMarathonParticipantImageByFileId.fulfilled, (state, action) => {
        state.marathonParticipantImageByFileId.response.loading = false;
        state.marathonParticipantImageByFileId.response.data = action.payload;
      })

      .addCase(getMarathonParticipantImageByFileId.rejected, (state, action) => {
        state.marathonParticipantImageByFileId.response.loading = false;
        state.marathonParticipantImageByFileId.response.error =
          action.payload as string || "Неизвестная ошибка";
        state.marathonParticipantImageByFileId.response.data = null;
      });
  },
});

export default marathonParticipantImagesSlice.reducer;